import React from 'react';
import { TopNav } from '../components/layout/TopNav';
import { EBTWICBanner } from '../components/layout/EBTWICBanner';
import { HeroSection } from '../components/sections/HeroSection';
import { ProductCard } from '../components/product/ProductCard';
import { RecipeBundle } from '../components/product/RecipeBundle';
import { TrustBadge } from '../components/ui/TrustBadge';
import { mockProducts } from '../data/mockProducts';
import { ArrowRight, Leaf, Clock, Shield, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function HomePage() {
  const featuredProducts = mockProducts.slice(0, 8);
  const jollofBundle = {
    title: 'Authentic Jollof Rice Kit',
    description: 'Everything you need for a family-sized pot of smoky Jollof rice.',
    products: [mockProducts.find(p => p.name.includes('Rice')) || mockProducts[0], mockProducts.find(p => p.name.includes('Maggi')) || mockProducts[1], mockProducts.find(p => p.name.includes('Oil')) || mockProducts[2], mockProducts.find(p => p.name.includes('Peppers')) || mockProducts[3]],
    totalPrice: 18.45,
    savings: 2.5
  };
  const categories = [{
    name: 'Fresh Produce',
    icon: '🥬',
    path: '/search?category=Produce'
  }, {
    name: 'Spices & Seasonings',
    icon: '🌶️',
    path: '/search?category=Spices'
  }, {
    name: 'Pantry Staples',
    icon: '🍚',
    path: '/search?category=Staples'
  }, {
    name: 'Household Items',
    icon: '👶',
    path: '/search?category=Household'
  }];
  return <div className="min-h-screen bg-[#FAF8F5]" data-id="element-328">
      <EBTWICBanner data-id="element-329" />
      <TopNav data-id="element-330" />
      <HeroSection data-id="element-331" />

      <main className="max-w-7xl mx-auto px-6 py-16 space-y-20" data-id="element-332">
        <section data-id="element-333">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-334">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-335">
              Shop by Category
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-336">
              Find authentic ingredients from across Africa and the Caribbean
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-337">
            {categories.map((cat, index) => <motion.div key={cat.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-338">
                <Link to={cat.path} className="group block bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-[#DC2626]/20 transition-all hover:-translate-y-1" data-id="element-339">
                  <div className="text-5xl mb-4" data-id="element-340">{cat.icon}</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#DC2626] transition-colors" data-id="element-341">
                    {cat.name}
                  </h3>
                  <div className="flex items-center text-[#DC2626] font-semibold text-sm" data-id="element-342">
                    Browse{' '}
                    <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-343" />
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </section>

        <section data-id="element-344">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-345">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-346">
              Curated Recipe Kits
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-347">
              Everything you need for your favorite dishes, bundled together
            </p>
          </motion.div>
          <div className="max-w-3xl mx-auto" data-id="element-348">
            <RecipeBundle {...jollofBundle} data-id="element-349" />
          </div>
        </section>

        <section data-id="element-350">
          <div className="flex items-center justify-between mb-12" data-id="element-351">
            <div data-id="element-352">
              <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-353">
                Weekly Essentials
              </h2>
              <p className="text-lg text-gray-600" data-id="element-354">
                Fresh arrivals and customer favorites
              </p>
            </div>
            <Link to="/search" className="hidden md:flex items-center gap-2 text-[#DC2626] font-semibold hover:gap-3 transition-all" data-id="element-355">
              View All Products <ArrowRight className="w-5 h-5" data-id="element-356" />
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-357">
            {featuredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-358" />)}
          </div>
        </section>

        <section className="bg-white rounded-3xl p-12 shadow-sm border border-gray-100" data-id="element-359">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-360">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-361">
              Why Pac-N-Post Plus?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-362">
              More than just a grocery store—we're your connection to home
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-363">
            {[{
            icon: Leaf,
            title: 'Authentic Quality',
            description: 'Sourced directly from trusted suppliers across Africa and the Caribbean'
          }, {
            icon: Clock,
            title: 'Same-Day Delivery',
            description: 'Order by 2 PM for delivery today. Free on orders over $35'
          }, {
            icon: Shield,
            title: 'WIC & EBT Accepted',
            description: 'Proud USDA-approved partner accepting all major benefit programs'
          }, {
            icon: Heart,
            title: 'Community First',
            description: 'Family-owned and dedicated to serving Upper Marlboro with care'
          }].map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="text-center" data-id="element-364">
                <div className="w-16 h-16 bg-gradient-to-br from-[#DC2626] to-[#B91C1C] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg" data-id="element-365">
                  <feature.icon className="w-8 h-8 text-white" data-id="element-366" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-367">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-368">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </section>

        <footer className="text-center py-12 border-t border-gray-200" data-id="element-369">
          <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-370">
            <TrustBadge type="USDA" data-id="element-371" />
            <TrustBadge type="SECURE" data-id="element-372" />
          </div>
          <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-373">
            Pac-N-Post Plus is proudly serving the Upper Marlboro community with
            fresh, culturally authentic groceries. We accept WIC, EBT/SNAP, and
            all major payment methods.
          </p>
          <p className="text-sm text-gray-500 mt-4" data-id="element-374">
            © 2024 Pac-N-Post Plus. All rights reserved.
          </p>
        </footer>
      </main>
    </div>;
}